import React from 'react';
import DevelopmentBanner from '../components/DevelopmentBanner';
import AppNavbar from '../components/AppNavbar';
import HeroSection from '../components/about/HeroSection';
import ProblemSection from '../components/about/ProblemSection';
import CentralizeSection from '../components/about/CentralizeSection';
import PrinciplesSection from '../components/about/PrinciplesSection';
import RoadmapSection from '../components/about/RoadmapSection';
import FAQSection from '../components/about/FAQSection';
import GetInvolvedSection from '../components/about/GetInvolvedSection';
import Footer from '../components/Footer';

const About = ({ isDarkMode, setIsDarkMode, featureControls }) => {
  return (
    <div className={`min-h-screen w-full ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <AppNavbar isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} featureControls={featureControls} />

      <DevelopmentBanner isDarkMode={isDarkMode} />

      {/* About Page Sections */}
      <main>
        <HeroSection isDarkMode={isDarkMode} />
        <ProblemSection isDarkMode={isDarkMode} />
        <CentralizeSection isDarkMode={isDarkMode} />
        <PrinciplesSection isDarkMode={isDarkMode} />
        <RoadmapSection isDarkMode={isDarkMode} />
        <FAQSection isDarkMode={isDarkMode} />
        <GetInvolvedSection isDarkMode={isDarkMode} />
      </main>
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

export default About;
